var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencilBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.711775 10.5014C0.728154 10.3964 0.777541 10.2994 0.852775 10.2244L10.9308 0.146393C11.0245 0.0526576 11.1517 0 11.2843 0C11.4169 0 11.544 0.0526576 11.6378 0.146393L15.5278 4.03639C15.6212 4.13012 15.6737 4.25706 15.6737 4.38939C15.6737 4.52173 15.6212 4.64867 15.5278 4.74239L5.44778 14.8214C5.37263 14.8963 5.27562 14.9453 5.17078 14.9614L0.575775 15.6674C0.498194 15.6793 0.418903 15.6728 0.344317 15.6483C0.269731 15.6239 0.201946 15.5822 0.146447 15.5267C0.0909477 15.4712 0.0492936 15.4034 0.0248552 15.3289C0.000416802 15.2543 -0.00611955 15.175 0.00577528 15.0974L0.710775 10.5034L0.711775 10.5014ZM1.67578 10.8154L1.09878 14.5754L4.85778 13.9974L14.4658 4.38939L11.2848 1.20739L1.67578 10.8154Z",
    fill: "#3D5DAF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2396 6.88448L8.70264 3.35448L9.40964 2.64648L12.9456 6.17648L12.2396 6.88448Z",
    fill: "#3D5DAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilBlue);
export default __webpack_public_path__ + "static/media/pencil_blue.72e3c8ac9edac7d30265032a6742f312.svg";
export { ForwardRef as ReactComponent };